// extracted by mini-css-extract-plugin
module.exports = {"btnInline":"style_btnInline__5Ex6v"};